import { Component } from '@angular/core';

@Component({
  selector: 'app-cost-calculator',
  templateUrl: './cost-calculator.component.html',
  styleUrls: ['./cost-calculator.component.css']
})
export class CostCalculatorComponent {
  // Default Simulation Values
  kiosks: number = 1;
  mobileBoxes: number = 1;
  offlineDonations: number = 200;
  communications: number = 200;
  needSim: boolean = false;
  needSetup: boolean = false;

  get totalDevices(): number {
    return this.kiosks + this.mobileBoxes;
  }

  get upfrontHardware(): number {
    if (this.totalDevices === 0) return 0;
    // 1st device is $399 (intro offer), additional devices are $299
    return 399 + ((this.totalDevices - 1) * 299);
  }

  get upfrontSetup(): number {
    return this.needSetup ? 100 : 0;
  }

  get totalUpfront(): number {
    return this.upfrontHardware + this.upfrontSetup;
  }

  get monthlyOffline(): number {
    // First 200 are free, then $0.10 each
    return Math.max(0, this.offlineDonations - 200) * 0.10;
  }

  get monthlyComms(): number {
    // First 200 are free, then $0.005 each
    return Math.max(0, this.communications - 200) * 0.005;
  }

  get monthlySim(): number {
    return this.needSim ? (this.mobileBoxes * 10) : 0;
  }

  get totalMonthly(): number {
    return this.monthlyOffline + this.monthlyComms + this.monthlySim;
  }
}